function mapTitles(titles, typesOfAcquisition, datesOfAcquisition) {
  titles = titles.map(title => (title || '').trim())
  typesOfAcquisition = typesOfAcquisition.map(type => (type ? type.trim() : ''))

  return titles.map(getFullTitles(titles, typesOfAcquisition, datesOfAcquisition))
}

function getFullTitles(titles, typesOfAcquisition, datesOfAcquisition) {
  return (currenTitle, index) => {
    const currentTypeOfAcquisition = typesOfAcquisition[index]

    let output = `${currenTitle || ''} ${currentTypeOfAcquisition || ''}`.trim()

    const otherTypesOfAcquisition = typesOfAcquisition.filter((title, i) => i !== index)
    const currentTypeIsSingle = !otherTypesOfAcquisition.includes(typesOfAcquisition[index])

    if (currentTypeIsSingle) {
      return output
    }

    const year = datesOfAcquisition[index] ? datesOfAcquisition[index].getFullYear() : ''

    if (!year) {
      return output
    }

    const otherYears = datesOfAcquisition.map(date => (date ? date.getFullYear() : '')).filter((_, i) => i !== index)
    const currentYearIsSingle = !otherYears.includes(year)

    if (currentYearIsSingle) {
      const yearString = datesOfAcquisition[index] ? `(${year})` : ''
      return `${output} ${yearString}`.trim().replace(/\s\s+/, ' ')
    }

    const month = datesOfAcquisition[index] ? `0${datesOfAcquisition[index].getMonth() + 1}`.slice(-2) : ''

    const monthYearString = `(${month}/${year})`
    return `${output} ${monthYearString}`.trim().replace(/\s\s+/, ' ')
  }
}

export default { mapTitles }
